var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEmojiWindow),expression:"showEmojiWindow"}],attrs:{"title":"Pick your emoji","emoji":"point_up","native":true},on:{"select":_vm.addEmoji}})}
var staticRenderFns = []

export { render, staticRenderFns }